import { Injectable } from '@angular/core';
import { Http, Response, RequestOptionsArgs, Headers, RequestOptions  } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AppConstants } from '../../app.constants';
import { HttpClient } from '../../services/http.service';

@Injectable()
export class AuthService {
  constructor(private httpClient: HttpClient, private appConstants: AppConstants) {

  }

  public ParentEmailForgot(email): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "CheckForgetPassword" + "?email=" + encodeURIComponent(email);
      console.log("ParentEmailForgot", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  public ParentEmailReset(email,password,token): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "SetForgetPassword" + "?email=" + encodeURIComponent(email) + "&password=" + encodeURIComponent(password) + "&sendtoken=" + token;
      console.log("ParentEmailReset", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  public ParentEmailLogin(email,password): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "CheckParentEmailLogin" + "?email=" + encodeURIComponent(email) + "&password=" + encodeURIComponent(password);
      console.log("ParentEmailLogin", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  public ParentEmailRegister(email,password,token): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "SetParentEmailPassword" + "?email=" + encodeURIComponent(email) + "&password=" + encodeURIComponent(password) + "&sendtoken=" + token;
      console.log("ParentEmailRegister", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  public CheckParentEmail(email): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "CheckParentEmailExists" + "?email=" + encodeURIComponent(email);
      console.log("CheckParentEmail", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  public CheckParentMobile(mobile): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "CheckParentPhonenumberExists" + "?phonenumber=" + encodeURIComponent(mobile);
      console.log("CheckParentMobile", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  public TeacherValidate(username, password): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "TeacherValidate?username=" + username + '&password=' + password;
    console.log("TeacherValidate", url);

    return this.httpClient.Post(url, {username: username, password: password})
        .map(this.extractData)
        .catch(this.handleError)
  }


  public TeacherValidateNew(username, password): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "ValidateSubjectTeacher?username=" + username + '&password=' + password;
    console.log("TeacherValidate", url);

    return this.httpClient.Post(url, {username: username, password: password})
        .map(this.extractData)
        .catch(this.handleError)
  }



    public ParentMobileLogin(mobile, code): Observable<Response> {
      let url: string = '' + this.appConstants.baseUrl + "CheckParentToken" + "?phonenumber=" + encodeURIComponent(mobile) + "&enteredtoken=" + encodeURIComponent(code);
      console.log("ParentMobileLogin", url);

      return this.httpClient.Get(url)
          .map(this.extractData)
          .catch(this.handleError)
  }

  private extractData(res: Response) {
      let body = res.json();
      return body;
  }

  private handleError(error: any) {
      let errMsg = (error.message) ? error.message :
          error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      let err: any;
      try {
        err = JSON.parse(error._body);
      } catch (error) {
        err = error._body;
      }
      return Observable.throw(err);
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/authentication/auth.service.ts